
















import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IClient } from "@/models/clients";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      clientId(state: IState) {
        return this.$_.get(state, "user.id", "");
      },
      client(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: this.dataModule,
          scope: this.clientScope
        });
      },
      clientScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/scope`](this.clientId);
      }
    })
  }
})
export default class ClientView extends Mixins(RequestPromises) {
  // Getters
  public clientId!: IClient["id"];
  public client!: IClient;
  public clientScope!: string;

  // Variables
  public dataModule = DataModules.CLIENTS;

  public isLoading = true;
  public isReloading = true;
  public requestError = false;

  public async created() {
    this.loadData();
  }

  public async loadData() {
    try {
      await this.getClientData(this.isReloading);
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }

    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getClientData(ignoreStored = false) {
    return this.$store.dispatch(
      `data/${this.dataModule}/getClientWithRelatedData`,
      {
        id: this.clientId,
        scope: this.clientScope,
        ignoreStored,
        vm: this
      }
    );
  }

  public beforeDestroy() {
    this.$store.dispatch("data/bin", {
      storeModule: this.dataModule,
      scope: this.clientScope,
      vm: this
    });
  }
}
